export default __webpack_public_path__ + "static/media/create-account.9a7744ba.svg";